import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["catalog", "group", "competencyList", "competencyEmpty", "competencyCount"]

  connect() {
    this.catalog = this.hasCatalogTarget ? JSON.parse(this.catalogTarget.textContent) : {}
    this.refresh()
    this.groupTargets.forEach((group) => this.applyListFilter(group))
  }

  filter(event) {
    const group = event.target.closest("[data-curriculum-entry-content-target='group']")
    if (!group) return
    this.applyListFilter(group)
  }

  applyListFilter(group) {
    const search = group.querySelector(".ct-picker__search")
    const query = search ? search.value.trim().toLowerCase() : ""
    const categoryBoxes = Array.from(group.querySelectorAll("[data-category-filter]"))
    const usesCategories = categoryBoxes.length > 0
    const allowed = new Set(categoryBoxes.filter((box) => box.checked).map((box) => box.value))
    let visible = 0

    group.querySelectorAll("[data-item]").forEach((item) => {
      const section = item.closest("[data-group]")
      const categoryOk = !usesCategories || (section && allowed.has(section.dataset.category || ""))
      const match = categoryOk && (query === "" || (item.dataset.name || "").includes(query))
      item.hidden = !match
      if (match) visible += 1
    })

    group.querySelectorAll("[data-group]").forEach((section) => {
      const anyVisible = Array.from(section.querySelectorAll("[data-item]")).some((item) => !item.hidden)
      section.hidden = !anyVisible
    })

    const empty = group.querySelector("[data-empty]")
    if (empty) empty.hidden = visible !== 0
    this.updateCategorySummary(group)
  }

  filterCategories(event) {
    const group = event.target.closest("[data-curriculum-entry-content-target='group']")
    if (!group) return

    const query = event.target.value.trim().toLowerCase()
    group.querySelectorAll("[data-category-row]").forEach((row) => {
      const match = query === "" || (row.dataset.name || "").includes(query)
      row.hidden = !match
    })
  }

  setCategories(event) {
    event.preventDefault()
    const group = event.currentTarget.closest("[data-curriculum-entry-content-target='group']")
    if (!group) return

    const check = event.currentTarget.dataset.categoryChoice === "all"
    group.querySelectorAll("[data-category-filter]").forEach((box) => {
      box.checked = check
    })
    this.applyListFilter(group)
  }

  updateCategorySummary(group) {
    const summary = group.querySelector("[data-category-summary]")
    if (!summary) return

    const boxes = Array.from(group.querySelectorAll("[data-category-filter]"))
    const checked = boxes.filter((box) => box.checked).length
    summary.textContent = checked === boxes.length
      ? `All ${boxes.length} categories`
      : `${checked} of ${boxes.length} categories`
  }

  preventSubmit(event) {
    if (event.key === "Enter") event.preventDefault()
  }

  remove(event) {
    event.preventDefault()
    const group = event.currentTarget.closest("[data-curriculum-entry-content-target='group']")
    const box = group && group.querySelector(`input[type="checkbox"][value="${event.currentTarget.dataset.id}"]`)
    if (box) box.checked = false
    this.refresh()
  }

  refresh() {
    this.groupTargets.forEach((group) => this.renderSelected(group))
    this.renderCompetencies()
  }

  renderSelected(group) {
    const selected = group.querySelector("[data-selected]")
    const count = group.querySelector("[data-count]")
    const boxes = Array.from(group.querySelectorAll('[data-item] input[type="checkbox"]:checked'))

    if (count) count.textContent = `${boxes.length} selected`
    if (!selected) return

    selected.textContent = ""
    boxes.forEach((box) => {
      const name = box.dataset.label || box.value
      const chip = document.createElement("span")
      chip.className = "ct-picker__chip"

      const label = document.createElement("span")
      label.textContent = name

      const button = document.createElement("button")
      button.type = "button"
      button.className = "ct-picker__chip-remove"
      button.dataset.action = "click->curriculum-entry-content#remove"
      button.dataset.id = box.value
      button.setAttribute("aria-label", `Remove ${name}`)
      button.textContent = "×"

      chip.appendChild(label)
      chip.appendChild(button)
      selected.appendChild(chip)
    })
  }

  renderCompetencies() {
    if (!this.hasCompetencyListTarget) return

    const ids = new Set()
    this.collectCompetencyIds("scenario", ids)
    this.collectCompetencyIds("skill", ids)

    const names = this.catalog.competencies || {}
    const items = Array.from(ids)
      .map((id) => names[id])
      .filter((name) => name)
      .sort((left, right) => left.localeCompare(right))

    this.competencyListTarget.textContent = ""
    items.forEach((name) => {
      const item = document.createElement("li")
      item.textContent = name
      this.competencyListTarget.appendChild(item)
    })

    if (this.hasCompetencyCountTarget) {
      const noun = items.length === 1 ? "competency" : "competencies"
      this.competencyCountTarget.textContent = `${items.length} ${noun}`
    }
    if (this.hasCompetencyEmptyTarget) this.competencyEmptyTarget.hidden = items.length > 0
    this.competencyListTarget.hidden = items.length === 0
  }

  collectCompetencyIds(kind, ids) {
    const map = (this.catalog && this.catalog[`${kind}s`]) || {}
    this.element.querySelectorAll(`[data-kind="${kind}"] [data-item] input[type="checkbox"]:checked`).forEach((box) => {
      const linked = map[box.value] || []
      linked.forEach((id) => ids.add(String(id)))
    })
  }
}
